import { Signal, WritableSignal } from "@angular/core";
import { BudgetAmounts, BudgetIntervalType } from "../../models/types/budget.types";
import { CollectionAbstraction } from "./collection.abstraction";
import { Observable } from "rxjs";

export abstract class ResultView {}

export class BudgetResultView extends ResultView {
  startDate: Date;
  interval: BudgetIntervalType;
  timeStamps: number[];
  budgetedAmount: number;
  resultsByIntervals: Map<number, BudgetAmounts>; // key is the timeStamp for end of each interval
}

export abstract class CalculatedResultCollection<
  Result extends ResultView,
> extends CollectionAbstraction {
  protected abstract _collection: WritableSignal<Result>;
  abstract collection: Signal<Result>;
  abstract collection$: Observable<Result>;

  protected abstract _cachedCollection: WritableSignal<Map<string, Result>>;
  abstract cachedCollection: Signal<Map<string, Result>>;
  abstract cachedCollection$: Observable<Map<string, Result>>;

  abstract update(collection: Result): void;
  abstract updateCache(key: string, result: Result): void;
  abstract clearCache(): void;
  abstract clearCollection(): void;
  abstract clear(): void;
}
